import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { DeliveriesService } from 'src/app/services/deliveries.service';
import { MetaService } from 'src/app/services/meta.service';

import * as moment from 'moment';

@Component({
  selector: 'app-dialog-delivery-date',
  templateUrl: './dialog-delivery-date.component.html',
  styleUrls: ['./dialog-delivery-date.component.css']
})
export class DialogDeliveryDateComponent implements OnInit {

  isLoading = false;
  deliveryDate;

  META_DATE = {
    startDate: '',
    endDate: ''
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private deliveriesService: DeliveriesService, private snackBar: MatSnackBar, private dialog: MatDialog, private META: MetaService) { }

  ngOnInit() {
    this.deliveryDate = this.data.deliveryDate;
    this.META.getMetaData().subscribe(result => {
      if (result.success) {
        this.META_DATE.startDate = result.data.query_dates.START_DATE;
        this.META_DATE.endDate = result.data.query_dates.END_DATE;
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onUpdate(ID: string, date) {
    this.isLoading = true;

    const data = new FormData();
    data.append('_id', ID);
    data.append('deliveryDate', moment(date).format('DD-MM-YYYY'));

    const filter = this.filter();

    this.deliveriesService.updateDeliveries(data).subscribe(result => {
      if (result.success) {
        this.deliveriesService.getDeliveries(filter).subscribe(result => {
          if (result.success) {
            this.deliveriesService.setDeliveries(result.data.deliveries);
            this.isLoading = false;
            this.dialog.closeAll();
            this.snackBar.open(`Delivery date updated`, 'Dismiss', {
              duration: 3000
            });
          }
        }, error => {
          this.isLoading = false;
          this.snackBar.open(error.error.data, 'Dismiss', {
            duration: 3000
          });
        });
      }
    }, error => {
      this.isLoading = false;
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  filter() {
    const filter = new FormData();

    if (this.data.filter.startDate == '') {
      filter.append('startDate', this.META_DATE.startDate);
    } else {
      filter.append('startDate', moment(this.data.filter.startDate).format('DD-MM-YYYY'));
    }

    if (this.data.filter.endDate == '') {
      filter.append('endDate', this.META_DATE.endDate);
    } else {
      filter.append('endDate', moment(this.data.filter.endDate).format('DD-MM-YYYY'));
    }

    if (this.data.filter.status == '' || this.data.filter.status == 'none') {
      filter.delete('status');
    } else {
      filter.append('status', this.data.filter.status);
    }

    if (this.data.filter.mobile == '') {
      filter.delete('mobile');
    } else {
      filter.append('mobile', this.data.filter.mobile);
    }

    if (this.data.filter.userMobile == '') {
      filter.delete('userMobile');
    } else {
      filter.append('userMobile', this.data.filter.userMobile);
    }

    if (this.data.filter.userName == '') {
      filter.delete('userName');
    } else {
      filter.append('userName', this.data.filter.userName);
    }

    return filter;
  }
}